import { render, staticRenderFns } from "./_RoutesDatabaseTable.vue?vue&type=template&id=d9b97e54"
import script from "./_RoutesDatabaseTable.vue?vue&type=script&lang=js"
export * from "./_RoutesDatabaseTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports